<template>

 
    <v-card 
      color="grey darken-2"
      :height="height"
    >
      <v-card-title><h4>{{title}}</h4></v-card-title>
      <v-spacer></v-spacer>
      <v-container fluid>
        <v-layout>
          <v-flex>
            <pie-chart
              :chart-data="data" 
              :options="options"
              :height="chartHeight"
              :width="chartWidth"
            ></pie-chart>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  
</template>

<script>
import PieChart from '../charts/PieChart'

export default {
  props: ['options','data','title', 'text','height'],
  components: {'pie-chart': PieChart},
  computed: {
    chartHeight: function () { return (this.height - 100)},
    chartWidth: function () { return (this.chartHeight - 100 )}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/PieChartCard.vue